export default __webpack_public_path__ + "static/media/icon-prev-pagination.d19ba4b7.svg";